import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import { useState } from "react";

import ScrollToTop from "./components/ScrollToTop";

import Home from "./routes/Home";
import Restaurant from "./routes/Restaurant";
import Cafe from "./routes/Cafe";
import Club from "./routes/Club";
import Art from "./routes/Art";
import Contact from "./routes/Contact";
import Colophon from "./routes/Colophon";
import HouseRules from "./routes/HouseRules";
import TermsAndConditions from "./routes/TermsAndConditions";
import CodeOfConduct from "./routes/CodeOfConduct";
import Disclaimer from "./routes/Disclaimer";
import BlogPost from "./routes/BlogPost";
import Jobs from "./routes/Jobs";

// import Login from './hollanddev/Login';

function App() {
  const [langNL, setLangNL] = useState(false);
  const location = useLocation();

  // const authorize = (e) => {
  //   console.log(window.sessionStorage)
  //   window.sessionStorage.setItem("hollanddev", "true");
  //   document.location.reload()
  // };
  // const token = window.sessionStorage.getItem("hollanddev");

  return (
    <React.StrictMode>
      <ScrollToTop />
      <TransitionGroup component={null}>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <Routes location={location}>
            {/*take out for client development*/}
            {/*  {!token ? <Route path="/" element={<Login auth={(e) => authorize(e)}/>} /> :
        <>*/}

            {/*<Route path="/testpage" element={<TestPage langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            {/*<Route path="/tickets" element={<Tickets langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}

            {/*<Route path="/program" element={<Program langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            {/*<Route path="/program" element={<Club langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            <Route
              path="/"
              element={
                <Home
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            {/* <Route
              path="/en"
              element={
                <Home
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="/nl"
              element={
                <Home
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="en/restaurant"
              element={
                <Restaurant
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="nl/restaurant"
              element={
                <Restaurant
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            /> */}
            <Route
              path="/restaurant"
              element={
                <Restaurant
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="/cafe"
              element={
                <Cafe
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            {/* <Route
              path="/en/cafe"
              element={
                <Cafe
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="/nl/cafe"
              element={
                <Cafe
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            /> */}
            <Route
              path="/club"
              element={
                <Club
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="/programme"
              element={
                <Club
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />

            {/* <Route path="/day" element={<Day langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} /> */}
            <Route
              path="/art"
              element={
                <Art
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            {/* <Route path="/cms" element={<CMS langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} /> */}

            {/* <Route
              path="nl/club"
              element={
                <Club
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="en/club"
              element={
                <Club
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            /> */}
            <Route
              path="/contact"
              element={
                <Contact
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="/jobs"
              element={
                <Jobs
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            {/*<Route path="/blog" element={<Blog langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            <Route
              path="/colophon"
              element={
                <Colophon
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="/house-rules"
              element={
                <HouseRules
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            {/*<Route path="/timeline" element={<Timeline langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            {/*<Route path="/privacy-policy" element={<PrivacyPolicy langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            <Route
              path="/terms-and-conditions"
              element={
                <TermsAndConditions
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            <Route
              path="/disclaimer"
              element={
                <Disclaimer
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            {/*<Route path="/weekhap" element={<Weekhap langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            {/*<Route path="/team" element={<Team langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} />*/}
            <Route
              path="/code-of-conduct"
              element={
                <CodeOfConduct
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />

            <Route
              path="/art/:postTitle"
              element={
                <BlogPost
                  langNL={langNL}
                  changeLang={(isNL) => {
                    setLangNL(isNL);
                  }}
                />
              }
            />
            {/* <Route path="/blog-post-edit/:postTitle" element={
        <BlogPostEdit langNL={langNL} changeLang={(isNL) => {setLangNL(isNL)}}/>} /> */}

            {/*take out for client development*/}
            {/*</>}*/}
          </Routes>
        </CSSTransition>
      </TransitionGroup>
    </React.StrictMode>
  );
}

export default App;
